import {createSlice} from '@reduxjs/toolkit';

interface videoText {
    textContent: string;
}
const initialState: videoText = {
    textContent: '',
};

export const videoSlice = createSlice({
    name: 'videoText',
    initialState,
    reducers: {
        getVideoText: (state: videoText, action: any) => {
            state.textContent = action.payload;
        },
    },
});

export const {getVideoText}: any = videoSlice.actions;

export default videoSlice.reducer;
